<template>
    <!-- Area editor dialog -->
    <div class="nopads">
        <span class="span-title">{{ $t('areas.area_name_prefix') }}</span>
        <div class="form-group">
            <input
                id="areaName"
                v-model="prefix"
                type="text"
                class="form-control form-control-sm"
                :class="{ 'is-valid': prefix && prefix.length > 1 }"
                :placeholder="$t('areas.prefix')"
                required
                autofocus
            />
        </div>
        <span class="span-title">{{ $t('areas.type') }}</span>
        <div class="form-group title">
            <label for="areaType">{{ $t('areas.type') }}</label>
            <select
                id="areaType"
                v-model="selectedAreaType"
                class="form-control form-control-sm"
            >
                <option v-for="type in areaTypes" :key="type.value" :value="type.value">
                    {{ type.text }}
                </option>
            </select>
        </div>
        <span class="span-title">{{ $t('areas.name_property') }}</span>
        <div class="form-group title">
            <label for="nameProp">{{ $t('areas.name_property') }}</label>
            <select
                id="nameProp"
                v-model="nameProp"
                class="form-control form-control-sm"
                :disabled="nameProps.length < 1"
            >
                <option v-for="prop in namePropsOptions" :key="prop.value" :value="prop.value">
                    {{ prop.text }}
                </option>
            </select>
        </div>
        <span class="span-title">{{ $t('tasktypes.color') }}</span>
        <color-picker
            @selectColor="(color) => setColor(color)"
            :default-color="selectedColor"
        />
        <div class="button-container top-margin">
            <button
                class="btn btn-success btn-lg"
                :disabled="!prefix || prefix.length < 1 || !selectedAreaType"
                @click.stop="addAll"
            >
                <span class="map-button-text">{{ $t('common.add') }}</span>
            </button>
        </div>
    </div>
</template>

<script>

import ColorPicker from "@/components/ColorPicker";
export default {
    name: 'AreaBulkDialog',
    components: {ColorPicker},
    props: {
        areaTypes: {
            type: Array,
            default() {
                return []
            }
        },
        nameProps: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            prefix: null,
            selectedAreaType: null,
            selectedColor: "#007bff",
            nameProp: null
        }
    },
    computed: {
        namePropsOptions() {
            return this.nameProps.map(item => ({text: item, value: item}))
        }
    },
    methods: {
        addAll: function () {
            this.$emit('addAll', this.prefix, this.selectedAreaType, this.selectedColor, this.nameProp)
        },

        setColor(color) {
            this.selectedColor = color
        }
    }
}
</script>

<style scoped>

</style>
